import { h, Fragment } from "preact";
import { useEffect, useState } from 'preact/hooks';
import { isValidTimeRange } from './timePickerValidation';
import './timePickerField.scss';

const TimePickerField = ({ selectedAvailability, startTime, endTime, setStartTime, setEndTime }) => {
    const [startTimeState, setStartTimeState] = useState({ hour: '', minute: '' });
    const [endTimeState, setEndTimeState] = useState({ hour: '', minute: '' });

    useEffect(() => {
        if (startTime) {
            const [hour, minute] = startTime.split(':');
            setStartTimeState({ hour, minute });
        } else {
            setStartTimeState({ hour: '', minute: '' });
        }
    }, [startTime]);

    useEffect(() => {
        if (endTime) {
            const [hour, minute] = endTime.split(':');
            setEndTimeState({ hour, minute });
        } else {
            setEndTimeState({ hour: '', minute: '' });
        }
    }, [endTime]);

    // Función para obtener los límites según la disponibilidad seleccionada
    const getRangeLimits = () => {
        switch (selectedAvailability) {
            case 'morning':
                return { minHour: 6, maxHour: 15 };
            case 'evenoon':
                return { minHour: 15, maxHour: 22 };
            case 'rotative':
                return { minHour: 0, maxHour: 23 };
            default:
                return { minHour: 6, maxHour: 22 };
        }
    };

    const { minHour, maxHour } = getRangeLimits();

    // Generar opciones de horas y minutos
    const generateHourOptions = () => {
        const options = [];
        for (let i = minHour; i <= maxHour; i++) {
            const hour = i.toString().padStart(2, '0');
            options.push(<option value={hour} key={hour}>{hour}</option>);
        }
        return options;
    };

    const generateMinuteOptions = (selectedHour) => {
        const options = [
            <option value="00" key="00">00</option>,
        ];
        if (selectedAvailability === 'morning') {
            const isLimitHour = selectedHour === '15';
            if (!isLimitHour) {
                options.push(<option value="30" key="30">30</option>);
            }
        } else {
            const isLimitHour = selectedHour === '22';
            if (!isLimitHour) {
                options.push(<option value="30" key="30">30</option>);
            }
        }
        return options;
    };


    const formatTime = ({ hour, minute }) => (hour && minute) ? `${hour}:${minute}` : '';

    const handleStartTimeChange = (field, value) => {
        const newTime = { ...startTimeState, [field]: value };
        setStartTimeState(newTime);
        setStartTime(formatTime(newTime));
    };

    const handleEndTimeChange = (field, value) => {
        const newTime = { ...endTimeState, [field]: value };
        setEndTimeState(newTime);
        setEndTime(formatTime(newTime));
    };

    return (
        <Fragment>
            {selectedAvailability && (
                <Fragment>
                    <p>Indica las horas en las que estarás disponible aproximadamente:</p>
                    <div className="row-2-el">
                        <div className="column-availability">
                            <label> Desde: <span className="required-asterisk">*</span></label>
                            <div className="time-select">
                                <select className="padd" value={startTimeState.hour} onChange={(e) => handleStartTimeChange('hour', e.target.value)} required>
                                    {generateHourOptions()}
                                </select>
                                <span>:</span>
                                <select className="padd" value={startTimeState.minute} onChange={(e) => handleStartTimeChange('minute', e.target.value)} required>
                                    {generateMinuteOptions(startTimeState.hour)}
                                </select>
                            </div>
                        </div>

                        <div className="column-availability">
                            <label> Hasta: <span className="required-asterisk">*</span></label>
                            <div className="time-select">
                                <select className="padd" value={endTimeState.hour}
                                        onChange={(e) => handleEndTimeChange('hour', e.target.value)} required>
                                    {generateHourOptions()}
                                </select>
                                <span>:</span>
                                <select className="padd" value={endTimeState.minute}
                                        onChange={(e) => handleEndTimeChange('minute', e.target.value)} required>
                                    {generateMinuteOptions(endTimeState.hour)}
                                </select>
                            </div>
                        </div>
                    </div>

                    {formatTime(startTimeState) && formatTime(endTimeState) && !isValidTimeRange(formatTime(startTimeState), formatTime(endTimeState)) && (
                        <p style={{ color: 'red' }}>La hora de finalización debe ser mayor que la hora de inicio.</p>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

export default TimePickerField;
